export function formatFullNameInitials(fullName: string): string {
  const parts = fullName.toUpperCase().split(/\s+/)
  if (parts.length == 0) {
    return ''
  } else if (parts.length == 1) {
    return parts[0][0] || ''
  } else {
    return parts[0][0] + parts[parts.length - 1][0]
  }
}
